'use strict';

var React = require('react');

var SvgPauseCircleMajor = function SvgPauseCircleMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 10c0 5.514 4.486 10 10 10s10-4.486 10-10-4.486-10-10-10-10 4.486-10 10zm7-3a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0v-6zm5-1a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1z"
  }));
};

exports.SvgPauseCircleMajor = SvgPauseCircleMajor;
